import React, { createContext,useState, useEffect, useReducer } from 'react';
import jwtDecode from 'jwt-decode';
import { ACCOUNT_INITIALISE, LOGIN, LOGOUT } from 'store/actions';
import axios from 'axios';
import accountReducer from 'store/accountReducer';
import Loader from 'component/Loader/Loader';
import { axiosClient } from 'utils/apiClient';
import serviceEndPoints from 'services/endPoints';



const initialState = {
    isLoggedIn: false,
    isInitialised: false,
    user: null,
    userId: null,
};

const verifyToken = (serviceToken) => {
    if (!serviceToken) {
        return false;
    }

    const decoded = jwtDecode(serviceToken);
    return decoded.exp > Date.now() / 1000;
};

export const setSession = (serviceToken, refreshToken) => {
    if (serviceToken && refreshToken) {
        localStorage.setItem('serviceToken', serviceToken);
	localStorage.setItem('refreshToken', refreshToken);
        axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
    } else {
        localStorage.removeItem('serviceToken');
	localStorage.removeItem('refreshToken');
        delete axios.defaults.headers.common.Authorization;
    }
};

export const logoutFn = () => {
    const serviceToken = window.localStorage.getItem('serviceToken');
    axiosClient.post(serviceEndPoints.auth.logout, "", {
        headers: { Authorization: 'Bearer ' + serviceToken }
    });
    window.sessionStorage.clear();
    setSession(null);
    window.location.href = '/login';
}

const JWTContext = createContext({
    ...initialState,
    login: () => Promise.resolve(),
    logout: () => { },
});


export const JWTProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [state, dispatch] = useReducer(accountReducer, initialState);
     const login = async (serviceToken,refreshToken, user, userId, values) => {
        const response = await axios.post(process.env.REACT_APP_SERVER_URL + serviceEndPoints.auth.login, values);
        const { token, data } = response.data;

        setSession(serviceToken, refreshToken);
        dispatch({
            type: LOGIN,
            payload: {
                user: data,
                userId: userId,
            },
        });
    };
    const logout = () => {
        const serviceToken = window.localStorage.getItem('serviceToken');
        axiosClient.post(serviceEndPoints.auth.logout, "", {
            headers: { Authorization: 'Bearer ' + serviceToken }
        }
        );
        setSession(null);
        dispatch({ type: LOGOUT });
    };

    useEffect(() => {
	const init = async () => {
            try {
                const serviceToken = window.localStorage.getItem('serviceToken');
		const refreshToken = window.localStorage.getItem('refreshToken');
                if (serviceToken && verifyToken(serviceToken)) {
                    setSession(serviceToken, refreshToken);
                    const response = await axios.get(process.env.REACT_APP_SERVER_URL + serviceEndPoints.auth.userfromtoken);
                    const user = response.data.data;
                    // menudispatch({ type: MENU_OPEN, isOpen:43 , isHeader:true }); // Add in the future
                    dispatch({
                        type: ACCOUNT_INITIALISE,
                        payload: {
                            isLoggedIn: true,
                            user: user,
                        },
                    });



                } else {
                    dispatch({
                        type: ACCOUNT_INITIALISE,
                        payload: {
                            isLoggedIn: false,
                            user: null,
                        },
                    });
                }
            } catch (err) {
                console.error(err);
                dispatch({
                    type: ACCOUNT_INITIALISE,
                    payload: {
                        isLoggedIn: false,
                        user: null,
                    },
                });
            }
        };

        init();
    }, []);

/*
export const JWTProvider = ({ children }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState);
    const login = async (serviceToken,refreshToken, user, userId, values) => {
        const response = await axios.post(process.env.REACT_APP_SERVER_URL + serviceEndPoints.auth.login, values);
        const { token, data } = response.data;
	
	setSession(serviceToken, refreshToken);
        dispatch({
            type: LOGIN,
            payload: {
                user: data,
                userId: userId,
            },
        });
    };

    const logout = () => {
        const serviceToken = window.localStorage.getItem('serviceToken');
        axiosClient.post(serviceEndPoints.auth.logout, "", {
            headers: { Authorization: 'Bearer ' + serviceToken }
        }
        );
        setSession(null);
        dispatch({ type: LOGOUT });
    };

    useEffect(() => {

        const init = async () => {
            try {
                const serviceToken = window.localStorage.getItem('serviceToken');
                if (serviceToken && verifyToken(serviceToken)) {
                    setSession(serviceToken);
                    const response = await axios.get(process.env.REACT_APP_SERVER_URL + serviceEndPoints.auth.userfromtoken);
                    const user = response.data.data;
		     
                    // menudispatch({ type: MENU_OPEN, isOpen:43 , isHeader:true }); // Add in the future
                    dispatch({
                        type: ACCOUNT_INITIALISE,
                        payload: {
                            isLoggedIn: true,
                            user: user,
                        },
                    });



                } else {
                    dispatch({
                        type: ACCOUNT_INITIALISE,
                        payload: {
                            isLoggedIn: false,
                            user: null,
                        },
                    });
                }
            } catch (err) {
                console.error(err);
                dispatch({
                    type: ACCOUNT_INITIALISE,
                    payload: {
                        isLoggedIn: false,
                        user: null,
                    },
                });
            }
        };

        init();

    }, []);

  */  
    if (!state.isInitialised) {
        return <Loader />;
    }

    return <JWTContext.Provider value={{ ...state, login, logout }}>{children}</JWTContext.Provider>;
};

export default JWTContext;
